module.exports = __webpack_public_path__ + "static/media/QR Code_V6.a3954548.jpg";